import React, { Component } from 'react'
import Flash from 'react-reveal/Flash';

export class AwardSection extends Component {
    render() {
        return (
            <section className="pricing-section" id="award">
                <div className="shape">
                    <img src={require("../../assets/image/landing-2-shape.svg")} alt="" />
                </div>
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-8">
                            <div className="section-title text-center">
                                <h2>Awards</h2>
                                <p>Come and hack for total prize of 100 Millions Rupiah</p>
                            </div>
                        </div>
                    </div>
                    <div className="custom-tab-wrapper monthly" id="pricing-tab-7">
                        <div className="row mb-d-30">
                            <Flash>
                                <div className="col-lg-4">
                                    <div className="pricing-card">

                                        <div className="card-head">
                                            <h5>1st</h5>
                                            <span className="card-badge">Winner</span>
                                            <h2>
                                                <span className="small-title">Rp</span>
                                                <span className="big-txt">50.000.000</span>
                                            </h2>
                                        </div>

                                        <div className="card-content">
                                            {/* <p>Bigger opportunity to be contracted</p> */}
                                        </div>
                                    </div>
                                </div>

                                <div className="col-lg-4">
                                    <div className="pricing-card">

                                        <div className="card-head">
                                            <h5>2nd</h5>
                                            <h2>
                                                <span className="small-title">Rp</span>
                                                <span className="big-txt">30.000.000</span>
                                            </h2>
                                        </div>

                                        <div className="card-content">
                                            {/* <p>Have an special opportunity to be contracted</p> */}
                                        </div>
                                    </div>
                                </div>


                                <div className="col-lg-4">
                                    <div className="pricing-card">

                                        <div className="card-head">
                                            <h5>3rd</h5>
                                            <h2>
                                                <span className="small-title">Rp</span>
                                                <span className="big-txt">20.000.000</span>
                                            </h2>
                                        </div>

                                        <div className="card-content">
                                            {/* <p>Have an opportunity to be contracted</p> */}
                                        </div>
                                    </div>
                                </div>
                            </Flash>
                            <div className="col-12">
                                <div className="pricing-extra-info">
                                    {/* <p><span>All awards will be payed in real money, not monopoly </span></p> */}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        )
    }
}

export default AwardSection
